import { render, staticRenderFns } from "./copeplan.vue?vue&type=template&id=4646a761&scoped=true&"
import script from "./copeplan.vue?vue&type=script&lang=js&"
export * from "./copeplan.vue?vue&type=script&lang=js&"
import style0 from "./copeplan.vue?vue&type=style&index=0&id=4646a761&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4646a761",
  null
  
)

export default component.exports